// TODO: T294944 Cleanup datastore.
import type { ServiceOfferingShopApi } from 'api-typings/service_offerings/service_offerings';
import type { ServiceOfferingShop } from './service-offering-shops.model';

export function transformServiceOfferingShops(
  serviceOfferingShop: ServiceOfferingShopApi,
): ServiceOfferingShop {
  return {
    id: serviceOfferingShop.id,
    ownerId: serviceOfferingShop.owner_id,
    name: serviceOfferingShop.name,
    description: serviceOfferingShop.description,
    bannerImageUuid: serviceOfferingShop.banner_image_uuid,
    bannerImageUrl: serviceOfferingShop.banner_image_url,
    attributes: serviceOfferingShop.attributes,
  };
}
